import run from '../../utilities/run';
import $ from 'jquery';
import _ from 'underscore';
import render from "../../utilities/render";
import fileUploader from '../../components/fileuploader/index';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

const sharedModalHtml = require("../../sharedHtml/modal.html");
const documentationModalBodyHtml = require("./html//documentation/documentationHtml.html");
const fileNameRowHtml = require('./html//documentation/documentationFileNameRow.html');

run("#order-detail-page", () => {
    const order = $("#order-detail-page").data("order");    
    const submitdocumentationURL = $("#order-detail-page").data("submit-document-url");
    const documentationFiles = $("#order-detail-page").data('document-files');
    const shippingDocumentUploadedFiles = $("#order-detail-page").data('shipping-document-uploaded');
    const fixDocumentBtn = "#order-detail-fix-doc-btn";
    const orderSubmitUrl = $("#order-detail-page").data("order-submit-url");;
    const pageReloadUrl = $("#order-detail-page").data("order-detail-page-reload-url");
    const fetchUploadedFilesURL = $("#order-detail-page").data("fetch-uploaded-files-url");
    let fetchUploadedFiles = [];

    const submitModalFlow = new SubmitModalFlow();
    submitModalFlow.init();
    const documentationModal = $(render(sharedModalHtml, {
        title: 'International Documentation Error',
        footerBtns: '<a href="#" class="base-btn purple-btn confirm-btn">Proceed</a><a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> ',
        body: render(documentationModalBodyHtml, {
            documentationFiles: renderDocumentFileNameValues()
          }),
        topCloseBtn: true,
        autoHideTop: true,
        modalDialogClass: "q-modal-dialog-1000"
    }));
    $('body').append(documentationModal);

    const confirmationTradeToolsModal = $(render(sharedModalHtml, {
        title: 'No Document(s) Uploaded',
        footerBtns: '<a href="#" class="base-btn purple-btn submit-btn">Next</a><a href="#" class="base-btn v2-btn purple-btn modal-auto-hide cancel-tradetool-btn">Cancel</a> ',
        body: '<div class="q-pad-all-xl">Document was not uploaded. Press ‘Cancel’ to go back and upload or press ‘Next’ to skip and proceed.</div>',
        topCloseBtn: true,
        autoHideTop: true,
        modalDialogClass: "q-modal-dialog-500"
    }));
    $('body').append(confirmationTradeToolsModal);
    
	let documentationFileUploader = new fileUploader({
        target: $(".documnet-uploader"),
        multiple: true,
        maxFileSize: 5,
        fileFormat:[".XLS",".XLSX",".DOC",".DOCX",".PDF",".TIFF",".TIF",
        ".JPG",".JPEG",".GIF",".TXT",".CSV"],
        accept:[".XLS",".XLSX",".DOC",".DOCX",".PDF",".TIFF",".TIF",
        ".JPG",".JPEG",".GIF",".TXT",".CSV"],
        afterValidSelection : function(){
          $(".select-files-btn").removeClass("disabled");
          renderSelectedFilesInRow(shippingDocumentUploadedFiles);
          validateFileLength();
        },
        afterInvalidSelection : function(){
            renderSelectedFilesInRow(shippingDocumentUploadedFiles);
        }
        });

        documentationFileUploader.init();	
        function renderSelectedFilesInRow(items) {
            const fileListHtml = (items).map((item, index) => {
              return render(fileNameRowHtml, {
                fileName: item.fileName,
                cisId: item.documentId
              });
            });
          $('.file-name-render-area').append(fileListHtml.join(""));
        }

        $(fixDocumentBtn).click(function() {
            buildFixBtnPopUp(documentationFileUploader, fetchUploadedFiles);
            showDocumentModal();
        });

        function  showDocumentModal(){
            documentationModal.modal('show');		
        }

        function  hideDocumentModal(){
            documentationModal.modal('hide');		
        }

        function renderDocumentFileNameValues() {
            let returnTypeList = "";
            returnTypeList = documentationFiles.map((el) => { 
              return render("<li>{%- key %}</li>", {
                key: el.fileName
              });
            });
            return returnTypeList.join('');
        }

        function validateFileLength(){
            $(".erroruploadMsg").hide();            
            let files = documentationFileUploader.getFiles();
            if(files != null && files.length  >= 11){
                $(".select-files-btn").addClass("disabled");
                $(".upload-file").addClass("disabled");
                $(".maxFileError").show();
            }
            else{
                $(".select-files-btn").removeClass("disabled");
                $(".upload-file").removeClass("disabled");
                $(".maxFileError").hide();

            }           
        }

        $('body').find(".mfu-file-input").on('change', validateFileLength);
        $('body').find(".file-remove-btn").on('click', validateFileLength); 

        $('body').find('.file-remove-btn-edit').on('click', function(e){
            e.preventDefault();
            let cisIdRemoved = $(this).children('#wo-cis-id').val();
            console.log(cisIdRemoved);
            for(let i =0; i< editFileList.length ; i++){
              if(cisIdRemoved == editFileList[i])
              editFileList.splice(i,1);
          }
          for(let i =0; i< woFiles.length ; i++){
            if(cisIdRemoved == woFiles[i].cisId)
            woFiles.splice(i,1);
        }
          $(this).closest(".file-name-row").remove();
          validateFileLength();
        });


        $(".upload-file").on("click", function (e) {          
            let formData = new FormData();
            let uploaderFiles =  documentationFileUploader.getFiles();
            let itnNumVal = $("#itnNumberInput").val();
            formData.append("ITNValue", itnNumVal);
            if (typeof uploaderFiles != "undefined") {
                uploaderFiles.forEach(file => { formData.append("files[]", file) });
            }
            $(".document-validation-loading-outer").show();		        
            $.ajax({
                data: formData,
                url: submitdocumentationURL,
                dataType:"JSON",
                type: 'POST',
                processData: false,  // tell jQuery not to process the data
                contentType: false,   // tell jQuery not to set contentType
                success: function(data){
                    if(data.response == "success") {
                        buildFixBtnPopUp(documentationFileUploader, fetchUploadedFiles);
                        $(".document-validation-loading-outer").hide();
                        $(".successUploadMsg").show();
                        $(".select-files-btn").addClass("disabled");
                        $("#wo-cis-id").addClass("disabled");
                        $(".file-remove-btn").addClass("disabled");
                        $(".upload-file").addClass("disabled");
                        
                    }else{
                        $(".document-validation-loading-outer").hide();
                        $(".erroruploadMsg").show();
                    }
                },
                error: function(data){
                    $(".document-validation-loading-outer").hide();
                    $(".erroruploadMsg").show();
                }
            });


        });

        $(".confirm-btn").on("click", function (e) {   
            hideDocumentModal();
            if(!$(".upload-file").hasClass("disabled")) {            
                confirmationTradeToolsModal.modal('show');
            }else{            
                confirmationTradeToolsModal.modal('hide');
                submitModalFlow.showLoadingModal();
                orderSubmit(orderSubmitUrl, order, submitModalFlow, pageReloadUrl);
            }
        });
        
        $(".cancel-tradetool-btn").on("click", function (e) {        
            buildFixBtnPopUp(documentationFileUploader, fetchUploadedFiles);
            showDocumentModal();
        });
        
        $(".submit-btn").on("click", function (e) {
            hideDocumentModal();
            confirmationTradeToolsModal.modal('hide');
            submitModalFlow.showLoadingModal();
            orderSubmit(orderSubmitUrl, order, submitModalFlow, pageReloadUrl);
        });
        
        function buildFixBtnPopUp(documentationFileUploader, fetchUploadedFile) {
            $(".erroruploadMsg").hide();
            $("#itnNumberInput").val("");
            $(".maxFileError").hide();
            $(".successUploadMsg").hide();
            $(".document-validation-loading-outer").hide();
            let uploadedFiles = documentationFileUploader.getFiles();
            $('.file-name-render-area').empty();
            $.ajax({
                data: {
                    orderId: order.ordOrderId
                },
                url: fetchUploadedFilesURL,
                dataType:"JSON",
                type: 'POST',
                processData: false,  // tell jQuery not to process the data
                contentType: false,   // tell jQuery not to set contentType
                success: function(data){ 
                    if(data != "") {
                        fetchUploadedFiles = data;                                                          
                        if (fetchUploadedFiles.length > 0) {
                            $(".select-files-btn").addClass("disabled");
                            $("#wo-cis-id").addClass("disabled");
                            $(".upload-file").addClass("disabled");
                            $(".file-remove-btn-edit").addClass("disabled");
                            renderSelectedFilesInRow(fetchUploadedFiles);
                        } else {
                            $(".upload-file").removeClass("disabled");
                            $(".select-files-btn").removeClass("disabled");
                            $("#wo-cis-id").addClass("disabled");
                        }
                    } 
                    showDocumentModal();                
                },
                error: function(data){               
                    showDocumentModal();
                }
            });
        }
        
        function orderSubmit(orderSubmitUrl, order, submitModalFlow, pageReloadUrl) {
            $.ajax({
                url: orderSubmitUrl,
                type: 'POST',
                dataType: 'JSON',
                data: {
                    orderId: order.ordOrderId,
                    callType: "documentValidation"
                },
                success: function (data) {
                    if (data.response == "success") {
                        submitModalFlow.showSuccessModal();
                        setTimeout(function () {
                            location.href = (pageReloadUrl);
                        }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
                    }
                },
                error: function (data) {
                    hideDocumentModal();
                }
            });
        }

});




// WEBPACK FOOTER //
// ./src/pages/order/documentValidation.js